import React from 'react';
import { Label } from '../ui/Label';
import { Input } from '../ui/Input';

const FormField = ({ 
  label, 
  icon: Icon, 
  value, 
  onChange, 
  placeholder, 
  error, 
  required = false,
  maxLength,
  ...props 
}) => {
  return (
    <div className="space-y-2">
      <Label className="flex items-center space-x-2 text-gray-900 dark:text-white">
        {Icon && <Icon className="w-4 h-4" />}
        <span>{label}</span>
        {required && <span className="text-red-500">*</span>}
      </Label>
      
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        className={error ? 'border-red-500 focus-visible:ring-red-500/20 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500' : 'text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500'}
        {...props}
      />
      
      {error && (
        <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  );
};

export default FormField;